import React from 'react'
import cn from 'classnames'
import Link from 'redux-first-router-link'
import ReactCSSTransitionReplace from 'react-css-transition-replace'
import { LOGIN_PAGE } from 'constants/pages'
import { Segment } from 'util/ui'
import { Icon, Header, Label } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'
import customersImage from 'assets/customers.png'
import styles from './styles.less'
import ProgressMeter from '../../ProgressMeter'

const Checkmark = () => {
  return (
    <Icon
      name="check"
      color={themeVars.groovyColorName}
      as="span"
      size={16}
      withoutPointer
    />
  )
}

const Variant2 = ({ page, children }) => {
  return (
    <React.Fragment>
      <div
        className={cn({
          [styles.Onboarding]: true,
          [styles['Onboarding-hideAside']]: page === 'AcceptInvitePage',
        })}
      >
        <section
          className={cn(
            styles.Onboarding_Main,
            styles['Onboarding_MainContent-fixedWidth']
          )}
        >
          <div className={styles.Onboarding_Logo}>GrooveHQ</div>
          <div className={styles.Onboarding_Login}>
            Already have an account?{' '}
            <Link to={{ type: LOGIN_PAGE }}>Sign in</Link>
          </div>
          <ProgressMeter />
          <div className={styles['Onboarding_MainContent-fixedWidth']}>
            <ReactCSSTransitionReplace
              transitionName="fade-wait"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
              overflowHidden={false}
            >
              <div
                key={page}
                className={styles['Onboarding_MainContent-fixedWidth']}
              >
                <Segment
                  raised
                  padded
                  className={styles.Onboarding_MainContent}
                >
                  {children}
                </Segment>
              </div>
            </ReactCSSTransitionReplace>
          </div>
        </section>
        <aside className={styles.Onboarding_Aside}>
          <Header size="small" fontType="display" weight="semiBold">
            Your trial Pro plan:
          </Header>
          <ul>
            <li>
              <Checkmark /> Live chat
            </li>
            <li>
              <Checkmark /> Unlimited {app.t('Mailboxes')}
            </li>
            <li>
              <Checkmark /> Assignments, @Mentions
            </li>
            <li>
              <Checkmark /> Rules
            </li>
            <li>
              <Checkmark /> Customizable Knowledge Base
            </li>
            <li>
              <Checkmark /> Reports (full history)
            </li>
            <li>
              <Checkmark /> 40+ Integrations
            </li>
          </ul>
        </aside>
      </div>
      <footer className={styles.Onboarding_Footer}>
        <Label as="div" className="grui mb-12">
          Trusted By
        </Label>
        <img
          src={customersImage}
          alt="Shopify, Keen IO, AT&T, Unsplash, CloudApp, HubSpot, 3DR, AppSumo, Meta Lab, and Statuspage"
          width="565"
          height="78"
          className={styles.Onboarding_Customers}
        />
      </footer>
    </React.Fragment>
  )
}

export default Variant2
